import React from "react";
import { Card, Grid } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import MenuSyncSettings from "../MenuSyncSettings";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useWatch } from "react-hook-form";

function Taurus() {
  const vestigingId = useWatch({ name: "id" });
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <FormTextTC
              name={"apiaccounts__taurusUrl"}
              tDefault={"Taurus URL (e.g. http://ip/easy4uas_web/awws/Easy4uAS.awws?WSDL)"}
              tKey={"vestigingen.form.taurus.label.taurusUrl"}
            />
            <FormTextTC
              name={"apiaccounts__taurusMachineID"}
              tDefault={"Taurus Machine ID (e.g. 123)"}
              tKey={"vestigingen.form.taurus.label.machineID"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/taurus/getTerminals?vid=${vestigingId}`, searchField: "naam" }}
              name={"apiaccounts__taurusTerminalID"}
              tDefault={"Taurus Terminal ID"}
              tKey={"vestigingen.form.taurus.label.terminalID"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/taurus/getMenus?vid=${vestigingId}`, searchField: "naam" }}
              multiple={true}
              name={"apiaccounts__taurusMenus"}
              tDefault={"Sync following menus"}
              tKey={"apiaccounts__taurusMenus"}
            />
          </Grid>

          <MenuSyncSettings />
        </CardBody>
      </Card>
    </div>
  );
}

export default Taurus;
